<template>
    <!-- Summary cards (Count, In payment, paid, sum) -->
    <div
        v-if="data.length > 0"
        class="d-flex mb-3"
        style="gap: 1rem; flex-wrap: wrap;"
    >
        <div class="card p-2 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('menu.contracts') }}</div>
                <div class="h2 mb-0">{{ totals.count }}</div>
            </div>
        </div>

        <div class="card p-2 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('daily_summary.invoice_state_not_invoiced') }}</div>
                <div class="h2 mb-0" style="color: #007BFF">{{ formatCurrency(totals.notInvoiced) }}</div>
            </div>
        </div>

        <div class="card p-2 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('daily_summary.ready_for_invoicing') }}</div>
                <div class="h2 mb-0 text-warning">{{ formatCurrency(totals.readyForInvoicing) }}</div>
            </div>
        </div>

        <div class="card p-2 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('daily_summary.rejected') }}</div>
                <div class="h2 mb-0 text-danger">{{ formatCurrency(totals.returned) }}</div>
            </div>
        </div>

        <div class="card p-3 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('invoice_history.total_sum') }}</div>
                <div class="h2 mb-0">{{ formatCurrency(totals.notInvoiced + totals.readyForInvoicing) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {invoicingHelper} from "../mixins/InvoicingMixin.js";

export default {
    name: 'NotInvoicedSummary',
    mixins: [invoicingHelper],
    props: {
        data: {type: Array, default: []}
    },
    computed: {
        totals() {
            const totals = { count: 0, notInvoiced: 0, readyForInvoicing: 0, returned: 0, sum: 0 }
            this.data?.forEach(i => {
                totals.count++
                if (i.not_invoiced > 0) {
                    totals.notInvoiced += Number(i.not_invoiced) || 0
                }
                if (i.ready_for_invoicing > 0) {
                    totals.readyForInvoicing += Number(i.ready_for_invoicing) || 0
                }
                if (i.returned > 0) {
                    totals.returned += Number(i.returned) || 0
                }
            })
            return totals
        }
    }
}

</script>

<style scoped>
.card { background: #fff; border: 1px solid #e6e6e6; border-radius: 4px; }

.stat-card {
    border-radius: 12px;
    border: 1px solid #e0e0e0;
   flex: 1 1 0;
    min-width: 200px;
}

</style>
